module.exports = __webpack_public_path__ + "img/tagbutton1.e88c4d61.png";